// Report that shows activity by hours
import React from 'react';
import styles from '../css/reports.module.css';
import { useState } from 'react';
import ReportsFooter from './ReportsFooter';

function ActivityByHrRpt({ reportData }) {
  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 20;

  //   Example data array. In real use, this would come from props or state.
  //Output only for demonstration purposes. Output a list of items for the current page with navigation buttons.
  // const dataTest = Array.from(
  //   { length: 50 },
  //   (_, i) => `Item ${i + 1}`,
  // );

  const start = (page - 1) * ITEMS_PER_PAGE;
  const end = start + ITEMS_PER_PAGE;
  const currentItems = reportData.slice(start, end);

  const totalPages = Math.ceil(reportData.length / ITEMS_PER_PAGE);
  return (
    <div className={styles.paginationContainer}>
      {reportData.length > 0 && (
        <table className={styles.reportTable}>
          <caption>Activity by Hours Summary</caption>
          <thead>
            <tr>
              <th>Hour</th>
              {currentItems.map((item) => (
                <th key={item.activityHour}>{item.activityHour}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  fontWeight: 'bold',
                }}
              >
                Tickets Count
              </td>
              {reportData.map((item) => (
                <td>{item.activitiesCount}</td>
              ))}
            </tr>
          </tbody>
        </table>
      )}
      {/* <ReportsFooter /> */}
      {/* <div>
        <button disabled={page === 1} className={styles.nextButton} onClick={() => setPage(1)}>
          {'<<'}
        </button>
        <button disabled={page === 1} className={styles.prevButton} onClick={() => setPage(page - 1)}>
          {'< Prev'}
        </button>

        <span>
          {' '}
          Page {page} of {totalPages}{' '}
        </span>

        <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(page + 1)}>
          {'Next >'}
        </button>
        <button disabled={page === totalPages} className={styles.nextButton} onClick={() => setPage(totalPages)}>
          {'>>'}
        </button>
      </div> */}
    </div>
  );
}
export default ActivityByHrRpt;
